// Звёзды оценки: ввод 1–5 (отзыв о поездке и отеле) и показ средней оценки
import { Icon } from './Icon';

/** Ввод оценки 1–5 */
export function StarsInput({ value, onChange }: { value: number; onChange: (n: number) => void }) {
  return (
    <div className="stars-input" role="radiogroup" aria-label="Оценка">
      {[1, 2, 3, 4, 5].map((n) => (
        <button type="button" key={n} role="radio" aria-checked={value === n} aria-label={`${n} из 5`} className={n <= value ? 'on' : ''} onClick={() => onChange(n)}>
          <Icon name="star" />
        </button>
      ))}
    </div>
  );
}

/** Показ оценки: закрашено округлённое число звёзд */
export function Stars({ value, size = 16 }: { value: number; size?: number }) {
  const full = Math.round(value);
  return (
    <span className="stars" aria-label={`Оценка ${value} из 5`} style={{ ['--star' as string]: `${size}px` }}>
      {[1, 2, 3, 4, 5].map((n) => <Icon key={n} name="star" className={n <= full ? 'on' : ''} />)}
    </span>
  );
}
